import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_e0edabf1-7bde-4cd6-aa89-d096d095407f/artifacts/cwa75nyj_TeamSportWorld_logo_cuadrado_HD_fondo_blanco.jpg";

export const Logo = ({ size = 40, withText = true, className = "" }) => (
  <Link to="/" data-testid="brand-logo" className={`flex items-center gap-2.5 ${className}`}>
    <img src={LOGO_URL} alt="TEAMSPORTWORLD" className="rounded-md object-contain" style={{ height: size, width: size }} />
    {withText && (
      <div className="leading-tight">
        <div className="font-display font-extrabold text-slate-900 text-lg tracking-tight">TEAMSPORTWORLD</div>
        <div className="text-[10px] text-emerald-600 font-bold tracking-[0.22em] uppercase">Pilot · Validation</div>
      </div>
    )}
  </Link>
);

export default Logo;
